import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useQueryParams from 'FormsUI/components/hooks/router/useQueryParams';
import { PROPERTIES } from '../constants';
import useQuickFilters from 'framework-listing-lib/hooks/useQuickFilters';
import { updateParams } from '../../../../actions/ReactRouter';
const useSyncQuickFiltersWithQueryString = () => {
  const dispatch = useDispatch();
  const queryParams = useQueryParams();
  const quickFilters = useQuickFilters();
  useEffect(() => {
    const hasTeamIdFilter = quickFilters.some(filterOperator => filterOperator.property === PROPERTIES.HUBSPOT_ALL_TEAM_IDS);
    if (!hasTeamIdFilter && queryParams.formTeam) {
      dispatch(updateParams({
        formTeam: undefined
      }));
    }
  }, [queryParams.formTeam, quickFilters, dispatch]);
};
export default useSyncQuickFiltersWithQueryString;